import React, { Component } from "react";
import FeedbackList from "../components/FeedbackList";
import axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
class FeedbackContainer extends Component {
  constructor() {
    super();
    this.state = {
      feedback: null,
      driver_id: null,
    };
  }

  componentDidMount() {
    this.send();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.driver_id !== this.state.driver_id) {
      this.send();
    }
  }
  send = () => {
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
      },
    };
    const url = this.state.driver_id
      ? `${API_ROOT}/deliveries/feedback?driver_id=${this.state.driver_id}`
      : `${API_ROOT}/deliveries/feedback`;
    axios.get(url, config).then((response) =>
      this.setState({
        feedback: response.data,
      })
    );
  };

  setDriver = (id) => {
    this.setState({ driver_id: id });
  };

  render() {
    return !this.state.feedback ? (
      <h1>Loading</h1>
    ) : (
      <div className="container-fluid pt-5">
        <h1>Customer Feedback - {this.state.feedback.count} reviews</h1>
        <FeedbackList
          feedback={this.state.feedback.deliveries}
          drivers={this.state.feedback.drivers}
          searchDriver={this.setDriver}
        />
      </div>
    );
  }
}

export default FeedbackContainer;
